export default __webpack_public_path__ + "static/media/pay_arrow.aa26fe52.png";